import { Injectable, Injector, inject } from '@angular/core';
import { ActivatedRouteSnapshot, ActivationEnd } from '@angular/router';

import { getToken } from '@frontend/sports/common/core/utils/router';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { OnAppInit } from '@frontend/vanilla/core';
import { filter, take } from 'rxjs';

import { SchemaMarkupType } from './schema-markup-enum';
import { ISchemaMarkupResolver } from './schema-markup.resolver';
import { SchemaMarkupService } from './schema-markup.service';

@Injectable({ providedIn: 'root' })
export class SchemaMarkupBoostrapService implements OnAppInit {
    private injector = inject(Injector);
    private routerEventsService = inject(RouterEventsService);
    private schemaMarkupService = inject(SchemaMarkupService);
    private productUtils = inject(SportsProductUtils);

    onAppInit(): void {
        this.routerEventsService.currentActivationEnd.pipe(this.productUtils.filterSports()).subscribe((event) => this.activationEnded(event));
    }

    private activationEnded(event: ActivationEnd | undefined): void {
        if (!event) {
            return;
        }

        const resolverType = this.findFirstSubnavigationResolver(event.snapshot);
        this.schemaMarkupService.removeSchemaMarkupScriptFromBody(SchemaMarkupType.SportsEvent);
        if (!resolverType) {
            return;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resolver = getToken<ISchemaMarkupResolver<any>>(resolverType, event.snapshot, this.injector);

        if (!resolver) {
            return;
        }

        const model = event.snapshot.data['model'];
        const events = resolver.resolve(model);
        this.schemaMarkupService.cleanEvents();

        events
            .pipe(
                take(1),
                filter((evnts) => evnts.length > 0),
            )
            .subscribe((evnts) => this.schemaMarkupService.addEventSchemaMarkup(evnts));
    }

    private findFirstSubnavigationResolver(snapshot: ActivatedRouteSnapshot): () => void {
        let crtSnapshot: ActivatedRouteSnapshot | null = snapshot;

        while (crtSnapshot && (!crtSnapshot.data || !crtSnapshot.data['schemaMarkup'])) {
            crtSnapshot = crtSnapshot.parent;
        }

        return crtSnapshot && crtSnapshot.data['schemaMarkup'];
    }
}
